// Hari K : 20-06-2023 : BT-99161 - Breeze - funds-viewBreakUp-start
import { memo, useEffect, useState } from "react";
import { BzModal, BzModalBody, BzModalHeader } from '../../components';
import { Row, Col, Container } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { handleModal } from "../../redux/actions/modals";
import { _commaFormatter, _kFormatter } from "../../controllers";

const FundsBreakupModal = () => {

    const dispatch = useDispatch();
    const modals = useSelector(state => state.modals.modals);
    const modalData = useSelector(state => state?.modals?.modalData);
    const [nExpandedParticular, setnExpandedParticulars] = useState('');

    // HAri k:20-12-2023: receiving data from modal and setting to local state
    useEffect(() => {
        setnExpandedParticulars(modalData?.particularId);
    }, [modalData]);

    const onHide = () => {
        dispatch(handleModal([{ "FUNDS_BREAKUP_MODAL": false }]));
    };

    const handleExpandParticulars = (value) => {
        if (nExpandedParticular === value.nId) {
            setnExpandedParticulars('');
        } else {
            setnExpandedParticulars(value.nId);
        }
    };

    return (
        <>
            {/* SumitG-08-12-23 */}
            <BzModal show={modals['FUNDS_BREAKUP_MODAL']} onHide={onHide} data-testid="funds-details-modal">
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={10} className='d-flex justify-content-start align-self-center'>
                                <div data-testid='funds-details-modal-title' className='font-medium font-size4 color-text'>Funds Details</div>
                            </Col>
                            <Col md={2} className='d-flex justify-content-end align-self-center'>
                                <div data-testid='funds-details-modal-close-icon' className='icon-16 icon-close icon-dark' onClick={onHide}></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    {modalData?.activePeriodiciti?.data?.map((each, i) => (
                        <Container fluid className='p-0' key={i}>
                            <div className='py-2'>
                                <Row data-testid={`funds-details-modal-particulars${i}`} className='g-0 mb-2' onClick={() =>  handleExpandParticulars(each)}>
                                    <Col md={7} className='d-flex justify-content-start align-self-center'>
                                        <div className='font-medium font-size4 color-text'>{each?.sDescription}</div>
                                    </Col>
                                    <Col md={5} className='d-flex justify-content-end align-items-center'>
                                        <div className='font-medium font-size4 color-text'>{_commaFormatter(_kFormatter(parseFloat((each?.nTrading).toFixed(2))))}</div>
                                        {each?.data.length ?
                                            each.nId === nExpandedParticular ?
                                                <div data-testid="funds-details-modal-up-icon" className='icon-14 icon-arrowup icon-dark ms-2'></div> :
                                                <div data-testid="funds-details-modal-down-icon" className='icon-14 icon-arrowdown icon-dark ms-2'></div>
                                            : null}
                                    </Col>
                                </Row>
                                {each?.nId === nExpandedParticular && each?.data.length ?
                                    <div data-testid="funds-details-modal-sub-particulars-card" className='transparent-card-wrap p-0 bdr-btm'>                                       
                                        <div className='transparent-card'>
                                            {
                                                each?.data?.map((breakupcash, i) =>
                                                    
                                                        <Row  className='g-0 py-1' key={i}>
                                                            <Col md={7} className='d-flex justify-content-start align-self-center'>
                                                                <div className='font-regular font-size2 color-subtext'>{breakupcash?.sDescription}</div>
                                                            </Col>
                                                            <Col md={5} className='d-flex justify-content-end align-self-center'>
                                                                <div className='font-regular font-size2 color-text'>{_commaFormatter(parseFloat(breakupcash?.nTrading).toFixed(2))}</div>
                                                            </Col>
                                                        </Row>
                                                
                                                )
                                            }
                                        </div>                                        
                                    </div>
                                : ''}
                            </div>
                        </Container>
                    ))}
                </BzModalBody>
            </BzModal>
        </>
    );
};

export default memo(FundsBreakupModal);
// Hari K : 20-06-2023 : BT-99161 - Breeze - funds-viewBreakUp-end
